import { Stack, StackItem, Tooltip } from "@octopus-energy/coral/atoms"
import { FormikCheckbox } from "@octopus-energy/coral/formik"
import { IconCircleInformationOutlined } from "@octopus-energy/icons"
import { useTranslations } from "next-intl"
import { consentCodeParsed } from "../../constants/consents"

export function CommunicationPreferencesFields() {
    const t = useTranslations("CommunicationPreferencesFields")

    return (
        <Stack
            flexDirection="column"
            attributes={{ "data-testid": "communication-preferences-fields" }}
        >
            <FormikCheckbox
                name={`consents.${consentCodeParsed.relationalCommunication}`}
                label={t("tips.label")}
            />
            <Stack
                gap="xxs"
                justifyContent="space-between"
            >
                <FormikCheckbox
                    name={`consents.${consentCodeParsed.commercialCommunication}`}
                    label={t("specialOffers.label")}
                />
                <StackItem flex="0 0 24px">
                    <Tooltip title={t("specialOffers.tooltip")}>
                        <IconCircleInformationOutlined />
                    </Tooltip>
                </StackItem>
            </Stack>
        </Stack>
    )
}

CommunicationPreferencesFields.messages = ["CommunicationPreferencesFields"] as const
